import store from '@/store'

const isAuthenticatedGuardSecretaria = async (to, from, next) => {

    const {ok, message} = await store.dispatch('secretaria/checkAuthentication')
    if(ok) next()
    else next({name: 'auth-secretaria'})
}

export default isAuthenticatedGuardSecretaria